  /*
  Copyright (C) 2021 owner Roman Piontik R.Piontik@mail.ru

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

          http://www.apache.org/licenses/LICENSE-2.0

  In any derivative products, you must retain the information of
  owner of the original code and provide clear attribution to the project

          https://dochub.info

  The use of this product or its derivatives for any purpose cannot be a secret.

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  */

import env, { Plugins } from '@front/helpers/env';
const listeners = {};

if (env.isPlugin(Plugins.idea)) {
  setInterval(() => {
    window.$PAPI.messagePull().then((message) => {
      if (message?.data) {
        for (const action in message.data) {
          (listeners[action] || []).forEach((listener) => {
            listener(message.data[action]);
          });
        }
      }
    });
  }, 300);
}

if (env.isPlugin(Plugins.vscode)) {
  window.addEventListener('message', (event) => {
    const { command, content } = event?.data;

    if (command === 'update-source-file') {
      for (const action in content) {
        (listeners[action] || []).forEach((listener) => {
          listener(content[action]);
        });
      }
    }

    if (command === 'navigate') {
      for (const action in content) {
        (listeners[action] || []).forEach((listener) => {
          listener(content[action]);
        });
      }
    }
  });
}

export default {
	appendListener(action, listener) {
		const arr = listeners[action] = (listeners[action] || []);
		arr.push(listener);
	},
	removeListener(action, listener) {
		const arr = listeners[action] = (listeners[action] || []);
		const index = arr.indexOf(listener);
		if (index >=0 ) arr.splice(index, 1);
	}
};
